import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './speechtype.routes';
import addHtml from './modal/add.html';

export class SpeechTypeController {
    $http;
    socket;
    awesomeThings = [];
    speechTypes = [];
    newThing = '';

    /*@ngInject*/
    constructor($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location) {
        this.$http = $http;
        this.socket = socket;
        this.$uibModal = $uibModal;
        this.$cookies = $cookies;
        this.$cookieStore = $cookieStore;
        this.$location = $location;


        // $scope.$on('$destroy', function() {
        //   socket.unsyncUpdates('search');
        // });
    }

    $onInit() {

        if (this.$cookies.get('token')) {
            this.$http.get('/api/speech_types/', {
                header: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'token': this.$cookies.get('token')
                },
                params: {
                    'page': 0,
                    'size': 20
                }
            })
                .then(response => {
                    if (response.data.data) {


                        this.maxSize = 20;
                        this.totalCount = response.data.count;
                        this.totalItems = response.data.count / 2;
                        this.currentPage = 1;

                        this.speechTypes = response.data.data;
                        this.socket.syncUpdates('speechTypes', this.speechTypes);
                    }

                });
        } else {
            this.$location.path('main')
        }
    }

    search(val) {
        if (val === true) {
            this.currentPage = 1;
        }
        const payload = angular.copy(this.filters);



        const ret = {
            filters: payload || {},
            page: this.currentPage - 1,
            size: 20
        };
        if (this.$cookies.get('token')) {

            this.$http.get('/api/speech_types/', {
                header: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'token': this.$cookies.get('token')
                },
                params: ret
            })
                .then(response => {
                    if (response.data.data) {
                        this.maxSize = 20;
                        this.totalCount = response.data.count;
                        this.totalItems = response.data.count / 2;
                        this.speechTypes = response.data.data;
                        this.socket.syncUpdates('speechTypes', this.speechTypes);
                    }
                });
        } else {
            this.$location.path('main')
        }
    }

    addSpeechType() {
        const speechTypes = this.speechTypes;
        this.$uibModal.open({
            template: addHtml,
            size: 'lg',
            /*@ngInject*/
            controller: function ($scope, $http, $uibModalInstance) {
                $scope.vm = {};
                $scope.save = function (myForm) {
                    if (myForm.$valid === false) {
                        return false;
                    } else {
                        $http.post('/api/speech_types/', $scope.vm).then((response) => {
                            $uibModalInstance.close(response.data.data);
                        }, (error) => {
                            console.log(error);
                        });
                    }
                };
                $scope.cancel = function () {
                    $uibModalInstance.close();
                };
            }
        })
            .result.then(function (data) {
                if (data) {
                    speechTypes.push(data);
                }
            }, function () {
            });
    }


    editSpeechType(type, index) {
        const speechTypes = this.speechTypes;
        this.$uibModal.open({
            template: addHtml,
            size: 'lg',
            /*@ngInject*/
            controller: function ($scope, $http, $uibModalInstance) {
                $scope.vm = angular.copy(type);
                $scope.save = function (myForm) {
                    if (myForm.$valid === false) {
                        return false;
                    } else {

                        $http.put('/api/speech_types/' + type.speech_type_id + '/', $scope.vm).then((response) => {
                            $uibModalInstance.close(response.data.data);
                        }, (error) => {
                            console.log(error);
                        });
                    }
                };
                $scope.cancel = function () {
                    $uibModalInstance.close();
                };
            }
        })
            .result.then(function (ret) {
                if (ret) {
                    speechTypes[index] = ret;
                }
            }, function () {
            });
    }



    deleteSpeechType(type, index) {
        this.$http.delete('/api/speech_types/' + type.speech_type_id + '/').then(response => {
            if (response.status === 204) {
                this.speechTypes.splice(index, 1)
            }
        }, error => {
            console.log(error);
        });
    }
}

export default angular.module('tttApp.speechtype', [uiRouter])
    .config(routing)
    .component('speechtype', {
        template: require('./speechtype.html'),
        controller: SpeechTypeController
    })
    .name;



// WEBPACK FOOTER //
// ./client/app/speechtype/speechtype.component.js